import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import LogoGym from "../../Picture/logoKekar.png";
import LogoAttendance from "../../Picture/logoAttendance.png";
import LogoInventory from "../../Picture/logoInventory.png";
import { useNavigate } from "react-router-dom";

const HomeGym2=(props)=>{
    const navigate = useNavigate();
    const [popUpLogout,setPopUpLogout]=useState(false);
    const url =props.url;
    

    // function Klik Ya
    const KlikYa=()=>{
        fetch(url + "/?op=logout", {
    credentials: "include",
  })
    .then((res) => res.json())
    .then((json) => {
      if (json === "logout") {
        navigate("/"); 
      }
    });

    }
    // fucntion Klik Tidak
    const KlikTidak=()=>{
        setPopUpLogout(false);
    }
    // function Klik Pilihan
    const KlikPilihan=(value)=>{
       
switch(value){
    case "attendance":
        navigate("/gym2/attendance");
        break;
        case "inventory":
            navigate("/gym2/inventory");
            break;
    default:break;
}
    }


   // use effect
       useEffect(()=>{
       fetch(url + "/?op=cekSession", {
           credentials: "include", 
         })
         .then((response)=>response.json())
         .then((json)=>{
          
         if (json === "kosong") {
               navigate("/", { replace: true });
             }else if(json ==="gym1"){
   navigate("/gym1", { replace: true });
             }else if(json ==="owner"){
   navigate("/owner", { replace: true });
             }
         })
       },[])
return(
    <div className={style.containerAll}>
        <div className={style.divJudul}>
 KEKE's GYM
 <div className={style.containerLogo}>
    <div onClick={()=>setPopUpLogout(true)} className={style.divLogo}>

    
    <img src={LogoGym}/>
    </div>
    <div style={{display:popUpLogout&&"none"}} className={style.divTulisanLogo}>
    Gym 2
    </div>
    <div style={{display:popUpLogout?"block":"none"}} className={style.divLogout}>
        <div className={style.judulDivLogout}>
Login dengan akun lain
        </div>
        <div className={style.isiDivLogout}>
<button onClick={()=>KlikYa()}>
    Ya
</button>
<button onClick={()=>KlikTidak()}>
    Tidak
</button>
        </div>
    </div>
 </div>
        </div>
        <div className={style.divIsi}>
            <div onClick={()=>KlikPilihan("attendance")} className={style.divKotak}>
<div className={style.divLogoKotak}>
<img src={LogoAttendance}/>
</div>
<div  className={style.keteranganKotak}>
Attendance
</div>
            </div>
            <div onClick={()=>KlikPilihan("inventory")} className={style.divKotak}>
<div className={style.divLogoKotak}>
<img src={LogoInventory}/>
</div>
<div  className={style.keteranganKotak}>
Inventory
</div>
            </div>
        </div>
    </div>
)
}
export default HomeGym2;